export default {
  首页: "مسكن",
  资产: "الأصول",
  币币: "العملة ",
  快捷买币: "تداول P2P",
  "支持多种方式购买，购买更简单": "دعم طرق متعددة للشراء ، وشراء أكثر بساطة",
  语言设置: "اعدادات اللغة",
  确认恢复: "تأكيد الاسترداد",
  "输入邮箱，方便我们联系您": "أدخل بريدك الإلكتروني حتى نتمكن من الاتصال بك",
  划转: "تحويل",
  行情: "يقتبس",
  "24H成交": "24H عملية تجارية",
  累计收益: "الدخل التراكمي",
  充值时间: "الوقت إعادة تعبئة الرصيد",
  到期时间: "تاريخ انتهاء الصلاحية",
  数量: "كمية",
  操作: "العمل",
  资产信息: "معلومات الأصول",
  复制地址: "نسخ العنوان",
  链名称: "اسم السلسلة",
  充值地址: "عنوان الشحن",
  收款地址: "عنوان الدفع",
  账单: "مشروع قانون",
  提现金额: "كمية السحب",
  接收地址: "عنوان الاستلام",
  交易密码: "عملية كلمة المرور",
  提现全部: "سحب كل شيء",
  保存图片: "احفظ الصورة",
  输入您的交易密码: "عملية كلمة المرور",
  确定: "بالتأكيد",
  地址: "تبوك",
  注册时间: "وقت التوقيع",
  取消: "يلغي",
  是否划转: "سواء لنقل",
  登录: "تسجيل الدخول",
  我的地址: "عنواني",
  登录密码和交易密码: "كلمة مرور تسجيل الدخول وكلمة مرور المعاملة",
  注册: "يسجل",
  密码: "كلمة المرور",
  设置密码: "ضبط كلمة السر",
  重复密码: "اعد كلمة السر",
  新密码: "كلمة السر الجديدة",
  确认新密码: "قم بتأكيد كلمة المرور الجديدة",
  充值: "تعبئة رصيد",
  充值货币: "تعبئة رصيد",
  合约账户充值: "إعادة شحن حساب العقود الآجلة",
  账户充值: "إعادة شحن الحساب",
  其他: "آخر",
  我的邀请码: "شفرة الدعوة",
  提现: "ينسحب",
  客服: "عميل",
  持有详情: "تفاصيل عقد",
  请输入内容: "الرجاء إدخال المحتوى",
  邀请好友来领取奖励: "ادعُ الأصدقاء لتلقي المكافآت",
  复制链接: "ينسخ",
  重复设置新的密码: "كرر تعيين كلمة مرور جديدة",
  保存: "يحفظ",
  我的: "مِلكِي",
  "邮箱/手机号": "البريد الإلكتروني / رقم الهاتف المحمول",
  备注: "ملاحظة",
  地址管理: "عنواني",
  我的团队: "فرق",
  联系我们: "اتصل بنا",
  竭诚为您服务: "مع خالص التقدير في خدمتكم",
  提取收益: "الدخل المنسحب",
  带给我的收益: "مصلحتي",
  添加: "يضيف",
  名称: "اسم",
  添加地址: "اضف عنوان",
  修改地址: "تغيير العنوان",
  可提现: "يمكن سحبها",
  安全中心: "مركز الأمنr",
  收益划转: "تحويل الدخل",
  通知中心: "تنبيه",
  "累计收益:": "الأرباح التراكمية:",
  注册用户: "مستخدم مسجل",
  奖励规则: "قواعد المكافأة",
  帮助反馈: "تعليمات المساعدة",
  邀请好友: "ادعو أصدقاء",
  恢复身份: "استعادة الهوية",
  选择语言: "اختر اللغة",
  设置新的密码: "قم بتعيين كلمة مرور جديدة",
  暂无活动: "لا يوجد نشاط",
  "月增长量(+)": "النمو الشهري (+)",
  可提取: "قابل للاستخراج",
  反馈类型: "نوع الأنطباع",
  赠送: "يتبرع",
  已经复制: "نسخ",
  保存成功: "تم الحفظ بنجاح",
  划转成功: "نقل ناجح",
  过期: "منتهي الصلاحية",
  提交成功: "تم الإرسال بنجاح",
  "服务器繁忙，稍后在试": "الخادم مشغول ، حاول لاحقًا",
  全部: "All",
  一级: "Level 1",
  二级: "Level 2",
  三级: "Level 3",
  级: "فصل",
  删除成功: "تم الحذف بنجاح",
  选择地址: "اختر العنوان",
  不再提醒: "لا تذكيرات",
  "最小充值金额：": "الحد الأدنى لإعادة الشحن:",
  选择币种: "اختر العملة",
  输入投资金额: "مبلغ الاستثمار",
  输入账户密码: "كلمة المرور",
  投资: "يستثمر",
  订单编号: "رقم التعريف الخاص بالطلب",
  投资周期: "دورة",
  投资资金: "أموال",
  投资时间: "زمن",
  状态: "حالة",
  投资中: "الاستثمار",
  已到期: "منتهي الصلاحية",
  暂无数据: "لايوجد بيانات",
  转入: "نقل في",
  邮箱: "بريد",
  请输入邮箱: "البريد الإلكتروني",
  请输入格式正确的邮箱: "عنوان البريد الالكترونى",
  请输入验证码: "رمز التحقق",
  获取验证码: "الحصول على رمز",
  请输入邀请码: "شفرة الدعوة",
  今天: "اليوم",
  昨天: "في الامس",
  最近七天: "الأيام السبعة الماضية",
  邀请: "يدعو",
  购买数量: "كمية الشراء",
  产品详情: "تفاصيل المنتج",
  币种: "عملة",
  利息币种: "عملة الفائدة",
  理财类型: "النوع المالي",
  产品费率: "سعر المنتج",
  进行中: "يعالج",
  每天: "كل يوم",
  请输入搜索关键词: "الرجاء البحث عن الكلمات الرئيسية",
  通知: "يلاحظ",
  查看更多: "أكثر",
  理财宝: "HODL واكسب",
  周期: "دورة",
  年利率: "أبريل",
  更多产品: "المزيد من المنتجات",
  灵活存取: "الودائع المرنة",
  稳定收益: "عوائد مستقرة",
  合约指南: "مركز المساعدة",
  资金划转出: "تحويل الأموال للخارج",
  矿池收益: "عائدات مجمع التعدين",
  提现手续费: "رسوم الانسحاب",
  冻结资金: "رسوم الانسحاب",
  解冻资金: "حرر الأموال",
  闪兑支出: "الإنفاق السريع",
  闪兑收入: "دخل الصرف السريع",
  闪兑手续费: "رسوم صرف فلاش",
  合约支出: "نفقات العقود الآجلة",
  合约收入: "عائدات العقود الآجلة",
  输入的金额不可大于可用金额:
    "لا يمكن أن يكون المبلغ الذي تم إدخاله أكبر من المبلغ المتاح",
  全部兑换成功: "بنجاح",
  返回: "يعود",
  查看历史: "عرض السجل",
  闪兑历史: "تاريخ فلاش",
  支付: "يدفع",
  获取: "الحصول على",
  时间: "زمن",
  手续费: "رسوم المعالجة",
  折扣: "تخفيض",
  价格: "سعر",
  逐仓: "معزول",
  全仓: "تعبر",
  市价委托: "أمر السوق",
  限价委托: "طلب محدود",
  请输入本金: "مقدار",
  请输入价格: "سعر",
  "可做空/做多": "قصير، طويل",
  设置止盈止损: "TP/SL",
  止盈价: "Est. TP",
  止损价: "Est. SL",
  成本: "كلفة",
  做多: "طويل",
  做空: "قصيرة",
  仓位信息: "معلومات الموقف",
  一键平仓: "أغلق الكل",
  永续: "مستدام",
  浮动盈亏: "الربح والخسارة",
  平仓: "قريب",
  反向开仓: "RVS مفتوح",
  一键撤销: "بنقرة واحدة للتراجع",
  倍杠杆: "x الرافعة المالية",
  执行价格: "سعر الإضراب",
  委托数量: "عدد الطلبات",
  保证金: "حافة",
  成交价: "سعر الفتح",
  创建时间: "تاريخ الإنشاء",
  撤销: "سحب او إبطال",
  合约市场: "سوق العقود الآجلة",
  交易方向: "اتجاه التداول",
  委托价格: "سعر الطلب",
  委托金额: "مبلغ العمولة",
  资金费率: "معدل التمويل",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "رسم متكرر يدفعه التجار على المدى الطويل والقصير ، ويتم تسويته كل 8 ساعات.",
  "资金费率为正，多方向空方支付资金费用。":
    "معدل التمويل إيجابي ، والجانب الطويل يدفع للجانب القصير رسوم التمويل.",
  "资金费率为负，空方向多方支付资金费用。":
    "معدل التمويل سلبي ، والجانب القصير يدفع رسوم التمويل للأطراف المتعددة.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "هل أنت متأكد أنك تريد فتح مركز في الشعر؟ سيتم شراء مركز الفتح العكسي بالمركز المعاكس الحالي",
  "仓位止盈/止损": "مركز جني الأرباح / وقف الخسارة",
  合约名称: "العقود الآجلة",
  开仓价格: "سعر الفتح",
  指数价格: "سعر المؤشر",
  止盈设置: "جني الأرباح",
  请输入止盈价: "الرجاء إدخال سعر جني الأرباح",
  "当指数价格触达*时，将会触发委托平仓":
    "عندما يلامس سعر الفهرس {0} ، سيطلق الأمر لإغلاق المركز",
  预计盈亏: "كمية التصفية",
  当前仓位: "الموقف الحالى",
  平仓金额: "مبلغ التصفية",
  仓位模式: "وضع الموقف",
  全仓模式: "وضع المستودع الكامل",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "تعتبر جميع الأموال المتاحة في حساب العقود الآجلة بمثابة هامش متاح. عندما تتجاوز خسارة المركز رصيد ccount ، سيتم تصفية المركز وخسارة جميع الهامش والمراكز. يرجى ملاحظة ذلك",
  逐仓模式: "وضع الهامش المعزول",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "سيؤدي ذلك إلى تخصيص مبلغ معين من الهامش في حساب العقود الآجلة للمركز. إذا انخفضت خسارة الهامش عن مستوى هامش الصيانة ، يتم تصفية المركز. في وضع الوضع المعزول ، يمكنك زيادة وتقليل الهامش لهذا المركز.",
  "是否撤销？": "هل ألغيت?",
  "是否一键撤销？": "هل هو التراجع بنقرة واحدة?",
  "是否一键平仓？": "ما إذا كان سيتم إغلاق المركز بنقرة واحدة?",
  持仓保证金: "هامش المركز",
  风险率: "مخاطرة",
  未实现盈亏: "الربح والخسارة غير المحققة",
  可用保证金: "الهامش الحر",
  净值: "قيمة جديدة",
  账户余额: "الرصيد",
  合约计算器: "آلة حاسبة",
  交易记录: "سجل المعاملات",
  "*倍杠杆": "{num} x",
  "平仓盈亏：": "إغلاق الربح والخسارة:",
  时间筛选: "مرشح الوقت",
  仓位类型: "نوع الوظيفة",
  订单状态: "حالة الطلب",
  订单类型: "نوع الطلب",
  平仓价格: "سعر نهائي",
  持仓数量: "كمية",
  "手续费(%)": "رسوم المعالجة (%)",
  平仓时间: "وقت الإغلاق",
  平仓类型: "نوع الإغلاق",
  手动平仓: "إغلاق المركز يدويًا",
  强制平仓: "التصفية القسرية",
  近1天: "1 يوم",
  近7天: "7 أيام",
  近30天: "30 أيام",
  近180天: "180 أيام",
  持仓: "موقع",
  已取消: "ألغيت",
  分时: "Time",
  "24H额(USDT)": "كمية 24 ساعة (USDT)",
  "24H低": "24H منخفض",
  "24H量(BTC)": "حجم 24H (BTC)",
  "24H高": "24H عالي",
  "10秒": "10 ثواني",
  "30秒": "30 ثواني",
  "1分": "1 نقطة",
  "3分": "3 نقطة",
  "5分": "5 نقطة",
  "30分": "30 نقطة",
  "1小时": "1 ساعة",
  "4小时": "4 ساعات",
  "8小时": "8 ساعات",
  "1天": "1 يوم",
  "1周": "1 أسبوع",
  "1月": "يناير",
  单向持仓: "موقف أحادي الاتجاه",
  杠杆: "رافعة",
  仓位: "موقع",
  计算结果: "نتائج الحساب",
  盈亏: "الربح والخسارة",
  收益率: "معدل العائد",
  计算结果仅供参考: "نتائج الحساب هي للإشارة فقط",
  成交后仓位大小: "حجم المركز بعد الصفقة",
  "计算结果仅供参考,实际结果可能因费率差异":
    "نتائج الحساب هي للإشارة فقط ، وقد تختلف النتائج الفعلية بسبب اختلافات الأسعار",
  目标价格: "استهداف",
  开始计算: "ابدأ الحساب",
  强平价格: "تصفية",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "قبل إعادة الشحن ، يرجى التحقق من اسم سلسلة الشحن بعناية. إذا كانت إعادة الشحن خاطئة ، فلا يمكن استرداد الأصول. {0} الحد الأدنى لمبلغ إعادة الشحن هو {1} ؛ إذا كان المبلغ أقل من هذا المبلغ ، فلن تتمكن المنصة من تأكيد الإيصال. يُرجى عدم إعادة شحن الأصول بخلاف {2} إلى هذا العنوان ، وإلا فلن يكون من الممكن استرداد الأصول ، يرجى عدم سحب عنوان التمويل الجماعي أو ICO مباشرةً ، فلن تعمل المنصة كوكيل لإصدار الرموز.",
  "最小输入*": "الحد الأدنى {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "الحد الأدنى لمبلغ السحب هو {0} ، وسيتم خصم رسوم السحب من مبلغ السحب. قبل سحب العملات المعدنية ، يرجى التأكيد والتحقق من عنوان الاستلام ، وعدم سحب {1} إلى عنوان آخر غير {2} ، وإلا فلن يتم استرداد الأصول. يُرجى عدم سحب عنوان التمويل الجماعي أو ICO مباشرةً ، فلن تتعامل المنصة مع إصدار الرموز.",
  退出登录: "خروج",
  加仓: "يضيف",
  新增仓位: "يضيف",
  输入加仓金额: "أدخل المبلغ",
  "当前可用:": "متاح حاليا:",
  资产账单: "فاتورة الأصول",
  保存二维码: "يحفظ QR code",
  温馨提示: "نصائح جيدة",
  "请注意：您当前使用的网络": "ملاحظة: شبكتك الحالية",
  输入提现地址: "أدخل عنوان السحب",
  "可用金额：": "المبلغ المتاح:",
  输入资产密码: "كلمة مرور الأصل",
  可用手续费: "رسوم المناولة المتاحة",
  "折扣%": "تخفيض%",
  实扣手续费: "رسم الخصم الفعلي",
  实际到账: "الائتمان الفعلي",
  未设置资产密码: "لم يتم تعيين كلمة مرور الأصل",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "لتأمين الأصول الخاصة بك ، يرجى تعيين كلمة مرور الأصل قبل الانسحاب.",
  热榜: "حار",
  涨幅榜: "ترتفع",
  跌幅榜: "الخاسر",
  成交额榜: "دوران",
  关于我们: "معلومات عنا",
  登录密码: "كلمة سر الدخول",
  设置: "Set up",
  资产密码: "تشفير الأصول",
  修改登录密码: "تعديل كلمة مرور تسجيل الدخول",
  原密码: "كلمة المرور القديمة",
  请输入新密码: "كلمة السر الجديدة",
  请输入原密码: "كلمة المرور الأصلية",
  确认密码: "تأكيد كلمة المرور",
  确定修改: "موافق للتعديل",
  修改资产密码: "تعديل كلمة مرور الأصل",
  验证码: "رمز التحقق",
  资产密码使用提示: "نصائح لاستخدام كلمة مرور الأصول",
  "资产密码用于转移、提取资产和交易。":
    "يستخدم Asset Crypto لنقل الأصول وسحبها والتداول.",
  "创建与登录密码不同的资产密码。":
    "قم بإنشاء كلمة مرور أصول مختلفة عن كلمة مرور تسجيل الدخول.",
  "定期更改您的资产密码。": "قم بتغيير كلمة مرور الأصول بانتظام.",
  提币历史: "تاريخ السحب",
  "金额/余额": "توازن كمية",
  "手续费/折扣": "توازن كمية",
  自选: "اختياري",
  现货: "بقعة",
  市价: "سعر السوق",
  止损设置: "إعداد وقف الخسارة",
  合约K线图: "مخطط K- الخط الآجل",
  "24H量": "24H الصوت",
  "24H额": "24H مقدار",
  合作指南: "دليل التعاون",
  盈亏计算: "P&L",
  当前可用: "متاح حاليا",
  请输入加仓金额: "الرجاء إدخال مبلغ الزيادة",
  请重新输入加仓金额: "الرجاء إعادة إدخال مبلغ الزيادة",
  平仓数量: "عدد الاغلاق",
  欢迎登录: "سجل الدخول من فضلك",
  "忘记密码?": "هل نسيت كلمة السر؟",
  "还没有账号？": "لا تملك حسابا حتى الآن؟",
  立即注册: "أفتح حساب الأن",
  繁體中文: "الصينية التقليدية",
  找回密码: "استرجاع كلمة السر",
  下一步: "الخطوة التالية",
  注册账户: "تسجيل حساب",
  "请输入邀请码(选填)": "كود الدعوة (اختياري)",
  谢邀豪礼: "دعوة",
  "24小时邀请好友排名": "24 ساعة دعوة الأصدقاء الترتيب",
  "*人": "{0}",
  "差*人": "{0}Gap",
  "已超过10万人，每月轻松赚钱":
    "لديها أكثر من 100000 شخص ، يكسبون المال بسهولة كل شهر",
  最高: "الأعلى",
  邀请链接: "Link",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "المنصة وأنت تشارك الرسوم التي يولدها أصدقاؤك على المنصة (الفوري ، العقود الآجلة ، الرافعة المالية ، تبادل الفلاش)",
  平台和您一起分享手续费: "تقاسم الرسوم معًا",
  "*级": "{0}level",
  规则: "قاعدة",
  我的好友: "أصدقاء",
  好友详情: "تفاصيل صديق",
  获得好友佣金方案: "احصل على برنامج عمولة صديق",
  我的等级: "My level",
  我的邀请数据: "بيانات دعوتي",
  当前等级: "المستوى الحالي",
  平台奖励您: "المنصة تكافئك",
  最高可获取平台奖励: "أقصى مكافأة متاحة",
  邀请规则: "قواعد الدعوة",
  "邀请*级有效好友": "دعوة فئة * أصدقاء صالحين",
  好友等级: "مستوى الصديق",
  人: "People",
  奖金派送: "تسليم المكافأة",
  平台奖励: "مكافأة المنصة",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "حق التفسير النهائي ينتمي إلى المنصة. إذا تبين أنه تم الحصول على مكافآت المنصة بشكل غير طبيعي ، فسيتم خصم جميع المكافآت ، وسيتم تجميد الحساب ، ولن يتم استرداد خسارة الأصول.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "يجب أن يكون حسابك حسابًا صالحًا ، ويحدد النظام الأساسي أن شرط الحساب الصحيح هو (إعادة شحن الحساب بأي عملة) الحد الأدنى لقيمة {0} USDT.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "يجب أن يكون الأصدقاء الذين تدعوهم مرؤوسين صالحين. تحدد المنصة أن المرؤوسين الصالحين هم (إعادة شحن الحساب بأي عملة) الحد الأدنى لقيمة {0} USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "لا يمكن أن تنتمي حسابات الداعي والمدعو لنفس عنوان IP..",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "يتم تقييم مستوى VIP من خلال عدد الأصدقاء رفيعي المستوى الذين تقوم بدعوتهم.",
  佣金成分: "مكون العمولة",
  收益统计: "إحصاءات الدخل",
  昨日收益: "أمس",
  月收益: "شهريا",
  获取收益: "دخل",
  "总收益：": "المجموع:",
  "*级好友": "{0} مستوى صديق",
  理财购买: "الشراء المالي",
  期限: "المصطلح",
  可用金额: "المبلغ المتاح",
  预估收益: "الارباح المتوقعه",
  申购上限: "حد الاشتراك",
  项目剩余: "المشروع المتبقي",
  "买入后预计*(SGT)开始计算收益。": "توقع أن تبدأ {0} (SGT) في الكسب.",
  计息日: "تاريخ الفائدة",
  申购日: "تاريخ الشراء",
  到账日: "تاريخ الوصول",
  到期自动续投: "التجديد التلقائي بعد انتهاء الصلاحية",
  申购: "الاشتراك",
  搜索理财项目: "ابحث عن البرامج المالية",
  超高年化随心选: "حرية الاختيار",
  "自由选择理财币种，稳定超额收益":
    "حرية اختيار عملة إدارة الثروات لتحقيق الاستقرار في العوائد الزائدة",
  理财总资产: "مبلغ الشراء",
  累计收益: "الدخل التراكمي",
  申购数量: "كمية الشراء",
  立即购买: "اشتري الآن",
  年化收益率: "APR",
  理财订单: "النظام المالي",
  持有: "يمسك",
  申购份额: "حصة الاشتراك",
  到账日期: "تاريخ الوصول",
  申购成功: "تم الاشتراك بنجاح",
  到期: "نضج",
  是否选择做多: "هل تختار أن تفعل المزيد",
  "可用余额为0 不能操作": "الرصيد المتاح 0 ولا يمكن تشغيله",
  福利中心: "الهبات",
  奖励记录: "سجل",
  我获取到的奖励: "المكافآت التي حصلت عليها",
  总价值: "القيمة الإجمالية",
  新手任务: "مهمة مبتدئ",
  身份认证: "المصادقة",
  身份验证: "المصادقة",
  去验证: "المصادقة",
  审核中: "قيد المراجعة",
  已验证: "تم التحقق",
  认证失败: "المصادقة فشلت",
  基础认证: "الشهادة الأساسية",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "يرجى ملاحظة أنه لا يمكن تعديل معلومات المصادقة بمجرد التحقق منها ، تأكد من ملء المعلومات الصحيحة",
  "国家/地区": "البلد / المنطقة",
  请选择: "من فضلك يختار",
  证件类型: "نوع الشهادة",
  证件编码: "رمز الوثيقة",
  身份证: "ID card",
  护照: "جواز سفر",
  驾驶证: "رخصة قيادة",
  请输入编码: "الرجاء إدخال الرمز",
  名字: "اسم",
  请输入: "تفضل",
  中间名: "الاسم الوسطى",
  选填: "اختياري",
  姓氏: "اللقب",
  中国: "الصين",
  身份上传: "تحميل الهوية",
  上传身份证: "تحميل ID",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "يجب تحميل المواد المذكورة أعلاه بتنسيق JPG / JPEG / PNG ، والتأكد من أن الحواف والزوايا الواضحة للصورة كاملة والسطوع موحد. والحجم لا يتجاوز {0} م.",
  确定提交: "تأكيد التقديم",
  去认证: "kyc",
  挑战任务: "مهمة التحدي",
  注册认证任务: "سجل لمهام الشهادة",
  完成注册认证即可领取: "بعد الانتهاء من شهادة التسجيل يمكنك الحصول عليها",
  领取奖励: "استلام جائزة",
  新人豪礼: "هدية الوافد الجديد",
  "参与人数：": "عدد المشاركين:",
  条件: "حالة",
  入金量: "إيداع",
  完成: "إنهاء",
  任务奖励: "مكافآت المهمة",
  距任务更新: "التحديث من المهمة",
  "条件：": "حالة:",
  活动规则: "حكم النشاط",
  奖励明细: "تفاصيل المكافأة",
  已获得: "مُقتَنىً",
  交易奖励: "مكافأة الصفقة",
  Win奖励: "مكافأة الصفقة",
  已领取: "تلقى",
  亏损金额超过: "مبلغ الخسارة يتجاوز",
  单笔开仓金额超过: "مبلغ الصفقة المفتوحة تتجاوز",
  交易量: "تجارة",
  待完成: "قيد الانتظار",
  入金: "إيداع",
  盈利金额超过: "مبلغ الربح يتجاوز",
  开仓金额: "مقدار",
  开仓金: "مركز مفتوح",
  盈利: "ربح",
  亏损: "خسارة",
  领取: "تسلم",
  未领取: "غير محسوب",
  待领取: "قيد الانتظار",
  再交易: "إعادة التداول",
  即可获得: "للحصول على",
  领取成功: "تم الاستلام بنجاح",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. سيتم احتساب جميع الأنشطة وفقًا لآخر وقت للنشاط ، وسيكون الدخل غير صالح بعد انتهاء الصلاحية.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. سيتم توزيع الدخل الذي تم الحصول عليه على حساب المكافأة الخاص بك ، ويمكنك استبداله وسحبه في أي وقت وفقًا لاحتياجاتك.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. سيتم إصدار نوع عملة المكافأة التي تم الحصول عليها وفقًا لنوع المهمة.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. حق التفسير النهائي ينتمي إلى المنصة. إذا تبين أن هناك وسائل غير طبيعية لمراجحة مكافأة المهام الخاصة بالمنصة ، فإن المنصة لها الحق في تجميد وتصفية الدخل الذي حصلت عليه.",
  成长学院: "مركز المساعدة",
  "区块链 & 加密货币": "Blockchain والعملات المشفرة",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "دليلك الشامل إلى العملات المشفرة ، نأخذك على طريق العملات المشفرة.",
  "全仓合约定单的全部保证金。": "الهامش الكامل لأمر العقود الآجلة المتقاطعة.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(الرصيد + (الربح والخسارة غير المحققة - رسوم المناولة - الرسوم الليلية) = الهامش الجديد / المستخدم * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    'سوف تؤثر الأرباح والخسائر غير المحققة بشكل مباشر على "الهامش المتاح". عندما يزداد الربح والخسارة غير المحققة ، سيزداد الهامش المتاح ، وينخفض الربح والخسارة غير المحققة ، كما سينخفض الهامش المتاح.',
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "الرصيد - (الهامش المستخدم) + (الربح والخسارة غير المحققة - رسوم المناولة - رسوم التبييت)",
  "注:可继续用于开仓的保证金。":
    "ملاحظة: الهامش الذي يمكن الاستمرار في استخدامه لفتح المراكز.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "الرصيد + (الربح والخسارة غير المحققة - رسوم المناولة - رسوم التبييت)",
  "注:当前的资金结余。": "ملاحظة: رصيد الصندوق الحالي.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "يشير إلى الرصيد الكامل لحساب العقود الآجلة ، بما في ذلك الرصيد غير المتاح.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "ملحوظة: كلما ارتفع معدل المخاطر ، انخفضت المخاطر ، وانخفض معدل المخاطرة ، زادت المخاطر.",
  该功能尚未开发: "لم يتم تطوير هذه الميزة",
  重置密码: "إعادة تعيين كلمة المرور",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "الرجاء إدخال 8-20 حرفًا ، ويجب أن يحتوي على أحرف وأرقام وأحرف خاصة ،",
  修改成功: "تم التعديل بنجاح",
  输入验证码: "شفرة",
  输入密码: "كلمة المرور",
  详情说明: "تفاصيل",
  已售罄: "نفذ",
  剩余期限: "حد اقصى",
  限期: "حد اقصى",
  闪兑货币选择: "اختيار العملات فلاش",
  地区选择: "اختيار المنطقة",
  "搜索国家/地区": "البحث في البلد",
  "身份信息已提交，将在*小时内审核完成":
    "تم إرسال معلومات الهوية وستتم مراجعتها في غضون {0} ساعة",
  "选择国家/地区": "حدد الدولة",
  "止盈价格需高于*": "يجب أن يكون سعر جني الأرباح أعلى من {0}",
  "止损价格需低于*": "يجب أن يكون سعر إيقاف الخسارة أقل من {0}",
  "止盈价格需低于*": "يجب أن يكون سعر جني الأرباح أقل من {0}",
  "止损价格需高于*": "يجب أن يكون سعر وقف الخسارة أعلى من {0}",
  教程详情: "تفاصيل البرنامج التعليمي",
  请输入止损价: "الرجاء إدخال سعر وقف الخسارة",
  活期: "مرن",
  赎回后立即到账: "ينسحب",
  赎回: "الخلاص",
  赎回理财: "الخلاص",
  是否赎回当前的理财订单:
    "ما إذا كان سيتم استرداد أمر إدارة الثروات الحالي أم لا",
  维护: "اعمال صيانة",
  "系统正在维护中……": "النظام تحت الصيانة ...",
  合约: "العقود الآجلة",
  闪电兑换: "مبادلة الفلاش",
  流水挖矿: "التعدين السحابي",
  邀请豪礼: "دعوة",
  计算器: "آلة حاسبة",
  最新价: "السعر الاخير",
  涨跌幅: "يتغيرون",
  关注币种添加自选: "اتبع العملة",
  一键添加自选: "يضيف",
  全标已读: "اقرأ كل شيء",
  无消息: "لا أخبار",
  "暂时还没有收到任何消息通知哦!": "لم يتم استلام رسالة!",
  没有更多数据: "لا أكثر",
  闪兑: "تبديل",
  从: "From",
  "可用余额：": "الرصيد：",
  至: "إلى",
  预览兑换结果: "معاينة",
  闪兑规则: "قواعد",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "قد يتغير تبادل فلاش السوق ، يرجى الرجوع إلى المبلغ الفعلي المستلم.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "يتم تحديد سعر الصرف من قبل طرف ثالث. بسبب تكاليف الصرف وتقلبات السوق ، قد يكون سعر الصرف الذي تقوم بتبادله أعلى من سعر الصرف في السوق. يرجى التأكيد بعناية قبل المتابعة.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "تفرض المنصة رسومًا على المناولة تبلغ حوالي {fee}٪ لكل بورصة ، والتي تُستخدم لدفع تكلفة الصرف في البورصة.",
  确认汇兑: "يتأكد",
  您预估得到: "تقدير",
  汇兑: "مبادلة الفلاش",
  汇兑比例: "نسبة",
  刷新: "ينعش",
  兑换: "مبادلة الفلاش",
  没有更多了: "لا أكثر",
  搜索币种: "يبحث",
  可用: "متوفرة",
  我知道了: "يعرف",
  最新价格: "أحدث السعر",
  确认: "Confirm",
  最大: "Max",
  "风险率(%)": "مخاطرة(%)",
  持仓: "موقع",
  当前委托: "ترتيب",
  合作交易历史记录: "تاريخ",
  重置: "إعادة ضبط",
  余额: "الرصيد",
  现货账户: "حساب التمويل",
  合约账户: "العقود الآجلة",
  WIN账户: "Win",
  赏金账户: "هدية",
  总资产折合: "معادل الأصول",
  今日收益: "اليوم",
  充币: "إيداع",
  提币: "ينسحب",
  账户权益: "رصيد الحساب",
  "数量/类别": "الكمية / النوع",
  全部币种: "جميع العملات المعدنية",
  全部类型: "كل الانواع",
  账单信息: "معلومات الفواتير",
  理财赎回: "الاسترداد المالي",
  购买理财: "شراء مالي",
  收入: "دخل",
  支出: "النفقات",
  到: "إلى",
  资产划转: "تحويل",
  "最少*": "دقيقة",
  "可用资产：": "الرصيد",
  确认划转: "تحويل",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "لا يمكن إجراء المعاملات إلا عن طريق تحويل الأصول إلى الحساب المقابل ، ولن يتم فرض رسوم مناولة على التحويلات بين الحسابات.",
  币种账户选择: "اختيار الحساب",
  选择账户: "اختيار الحساب",
  划转详情: "تفاصيل التحويل",
  划转明细: "تفاصيل التحويل",
  收入账单: "فاتورة الدخل",
  支出账单: "مشروع قانون الانفاق",
  金额: "مقدار",
  总收益: "المجموع",
  佣金: "جائزة",
  用户名: "اسم االمستخدم",
  "已领取：": "تلقى：",
  "未领取：": "لم يتم الاستلام：",
  "请选择国家/地区": "الرجاء تحديد البلد / المنطقة",
  请上传身份信息: "يرجى تحميل المعرف",
  请选择证件类型: "الرجاء تحديد نوع الوثيقة",
  请填写证件编码: "يرجى ملء رقم الهوية",
  请填写名字: "الرجاء إدخال الاسم",
  请填写姓氏: "الرجاء إدخال الاسم الأخير",
  单向持仓: "عقد في اتجاه واحد",
  投资金额: "مقدار",
  天: "يوم",
  请输入手机号: "هاتف",
  搜索: "يبحث",
  搜索历史: "سجل البحث",
  热门推荐: "حار",
  "《Xspace Earn协议》": "《بروتوكول Xspace Earn》",
  我已了解并同意: "أنا أفهم وأوافق",
  协议: "بروتوكول",
  Xspace官方中文交流群: "مجموعة Xspace الصينية الرسمية",
  Xspace官方英文交流群: "Xspace Official English Group",
  预计维护至: "من المتوقع أن",
  更多功能: "أكثر",
  下载APP: "تحميل",
  理财: "الأمور المالية",
  推荐: "نوصي",
  Telegram官方中文频道: "قناة Telegram الصينية الرسمية",
  Telegram官方英文频道: "قناة Telegram الإنجليزية الرسمية",
  官方邮箱: "البريد الإلكتروني الرسمي",
  客服邮箱: "البريد الإلكتروني لخدمة العملاء",
  上述信息最终解释权归官方所有: "يعود حق التفسير النهائي إلى المسؤول",
  IOS版下载: "تنزيل لـ IOS",
  Android版下载: "تنزيل لنظام Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "رسوم المناولة = رسوم معالجة الشراء + معدل التمويل + رسوم معالجة البيع",
  资金划转: "تحويل",
  止盈: "TP",
  止损: "SL",
  自动平仓: "إغلاق تلقائي",
  委托挂单: "امر مؤتمن معلق",
  买: "يشتري",
  卖: "باع",
  "买入/做多": "شراء / طويل",
  "卖出/做空": "البيع / البيع",
  详情: "تفاصيل",
  浮动涨跌: "الصعود والهبوط",
  最小: "Min",
  充币数量: "مبلغ الشحن",
  请输入充币数量: "مبلغ الشحن",
  支付截图: "لقطة شاشة الدفع",
  提交: "تقديم",
  上传驾驶证: "تحميل رخصة القيادة",
  上传护照: "تحميل جواز السفر",
  加载中: "جار التحميل",
  上传成功: "النجاح",
  充值历史: "تاريخ",
  合约卖出手续费: "رسوم العقد",
  合约买入手续费: "رسوم العقد",
  系统加款: "إضافة النظام",
  系统减款: "تخفيض النظام",
  合约资金费率: "معدل تمويل العقد",
  佣金分成: "حصة العمولة",
  U本位合约: "عقد",
  资产管理: "أصول",
  APP下载: "تنزيل التطبيق",
  全球领先的数字理财平台: "منصة إدارة الثروات الرقمية الرائدة في العالم",
  "即刻交易比特币、以太坊等上百种数字资产":
    "تداول على الفور مئات الأصول الرقمية مثل Bitcoin و Ethereum",
  "24H涨跌幅": "24H التغيير",
  查看更多行情: "عرض المزيد من الاقتباسات",
  近24小时成交量: "الحجم في آخر 24 ساعة",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "توفير المئات من أزواج العملات والعقود التجارية لتلبية احتياجات التداول المتنوعة. تضم المنصة أكثر من 20 مليون مستخدم في 200 دولة ومنطقة ، وهي منصة خدمات الأصول الرقمية الرائدة في العالم.",
  用户国家分布: "توزيع بلد المستخدم",
  用户数: "رقم المستخدم",
  交易对: "زوج التداول",
  服务支持: "دعم الخدمة",
  "随时随地，多平台终端交易":
    "في أي وقت وفي أي مكان ، معاملات طرفية متعددة المنصات",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "متعدد المحطات متوافق تمامًا ويمكنه تلبية احتياجات المعاملات لسيناريوهات مختلفة في أي وقت.",
  随时查看实时行情: "عرض الأسعار في الوقت الحقيقي في أي وقت",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "يمكنك شراء وبيع BTC و ETH و DOGE والأصول الرقمية الأخرى بسهولة",
  获取您关注的加密货币价格变化预警:
    "احصل على تنبيهات بشأن تغيرات أسعار العملات المشفرة التي تهتم بها",
  "查看比特币现货、期货、期权价格":
    "عرض أسعار Bitcoin الفورية والعقود الآجلة والخيارات",
  比较各交易所加密货币价格: "قارن أسعار العملات المشفرة عبر البورصات",
  开启您的数字货币之旅: "ابدأ رحلة عملتك الرقمية",
  快捷购买数字货币: "شراء العملات الرقمية بسرعة",
  "使用多种支付方式交易数字货币，安全快捷":
    "استخدم مجموعة متنوعة من طرق الدفع لتداول العملات الرقمية بطريقة آمنة وسريعة",
  最优的交易费率: "أفضل سعر للصفقة",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "أسعار معاملات تفضيلية وحقوق VIP تنافسية تتمتع بأفضل جودة خدمة",
  可信赖的安全保障: "أمان موثوق",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "تعمل إجراءاتنا الأمنية المتطورة وأموال SAFU على حماية أصولك الرقمية من جميع المخاطر.",
  交易: "تجارة",
  币币市场: "سوق العملات",
  "24H成交量": "حجم 24H",
  交易所: "تبادل",
  "24H最高": "24 ساعة عالية",
  "24H最低": "24 ساعة منخفضة",
  永续合约: "عقد دائم",
  日涨跌: "يتغيرون",
  交易深度: "عمق الصفقة",
  "资产(合约)": "الأصول (العقود)",
  历史仓位: "تاريخي",
  兑换记录: "سجل الصرف",
  类型: "يكتب",
  充值记录: "سجل الشحن",
  划转记录: "سجل التحويل",
  类别: "فئة",
  历史账单: "تاريخي",
  在线充值: "تعبئة رصيد",
  安全设置: "اعدادات الامان",
  用于账户登录使用: "لاستخدام تسجيل الدخول إلى الحساب",
  用户提现时安全验证使用:
    "التحقق من الأمان واستخدامه عند قيام المستخدمين بسحب النقود",
  验证: "يؤكد",
  万: "عشرة آلاف",
  随时随地开启交易: "تجارة. في أى مكان.",
  "*货币交易所的所有功能尽在你的手中。": "كل وظائف {0} صرف العملات بين يديك.",
  "下载*货币交易所APP。": "قم بتنزيل تطبيق صرف العملات {0}.",
  下载自: "التحميل من",
  内测版: "بيتا مغلق",
  下载: "تحميل",
  扫码下载: "تفحص للتحميل",
  设置您的资产密码: "قم بإعداد كلمة مرور الأصول الخاصة بك",
  法币: "عملة ورقية",
  我要买: "أريد شراء",
  我要卖: "أريد أن أبيع",
  请输入金额: "الرجاء إدخال المبلغ",
  汇率: "سعر الصرف",
  获得: "احصل على",
  支付通道: "قناة الدفع",
  收款通道: "قناة التحصيل",
  "出售过程需要务必确认好您的收款方式为本人。":
    "أثناء عملية البيع ، تحتاج إلى تأكيد أن طريقة الدفع الخاصة بك هي لك.",
  当前法币暂不支持交易对可尝试前往提现:
    "العملة القانونية الحالية لا تدعم زوج التداول ، يمكنك محاولة الانسحاب",
  前往提现: "اذهب إلى صرف النقود",
  该法币暂无通道: "لا توجد حاليا قناة لهذه العملة الورقية",
  "正在出售中，请耐心等待": "للبيع ، يرجى التحلي بالصبر",
  请选择支付通道: "الرجاء تحديد قناة الدفع",
  请选择方式: "الرجاء تحديد طريقة",
  法币历史: "تاريخ فيات",
  买币: "شراء العملات المعدنية",
  卖币: "بيع العملات المعدنية",
  失败: "يفشل",
  已完成: "منجز",
  未付款: "غير مدفوعة",
  待审核: "في انتظار المراجعة",
  打款中: "الدفع",
  订单详情: "تفاصيل الطلب",
  联系客服: "اتصل بخدمة العملاء",
  到账金额: "تم استلام المبلغ",
  通道: "ممر",
  收款人: "المستفيد",
  收款账户: "الذمم المدينة",
  "订单出售失败，请查下方失败原因":
    "فشل الأمر في البيع ، يرجى التحقق من سبب الفشل أدناه",
  失败原因: "سبب الفشل",
  您还未进行付款: "لم تقم بالدفع",
  您已成功购买: "لقد اشتريت بنجاح",
  已取消订单: "تم الغاء الأمر او الطلب",
  "订单正在审核中，请耐心等待": "الطلب قيد المراجعة ، يرجى التحلي بالصبر",
  您已成功出售: "لقد بعت بنجاح",
  "订单正在打款中，请耐心等待": "يتم دفع الطلب ، يرجى التحلي بالصبر",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "تتطلب عملية الدفع أن تذهب إلى منصات أخرى للدفع مقابل الطلبات ، يرجى الانتباه لأمن المعلومات.",
  当前法币暂不支持交易对可尝试前往充值:
    "لا تدعم العملة الورقية الحالية أزواج التداول ، يمكنك محاولة إعادة الشحن",
  前往充值: "اذهب لإعادة الشحن",
  购买: "يشتري",
  订单号: "رقم الطلب",
  单价: "سعر الوحدة",
  到账数量: "مبلغ الحساب",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "توجد حاليًا طلبات غير مدفوعة ، هل تريد الاستمرار في بدء أمر دفع جديد؟",
  继续支付: "الاستمرار في الدفع",
  重新下单: "إعادة الطلب",
  是否确定出售: "هل أنت متأكد من البيع",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "بعد تأكيد البيع ، سيتم تخصيص المنصة للمشتري ، يرجى الانتظار بصبر حتى تتطابق المنصة.",
  出售: "باع",
  收款方式: "طريقة الدفع او السداد",
  订单已生成: "تم إنشاء الطلب",
  取消订单: "الغاء الطلب",
  请在: "من فضلك في",
  内完成付款: "إتمام الدفع في غضون",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "اترك المنصة ، وقم بتسجيل الدخول إلى الدفعة التي حددتها ، وقم بالتحويل إلى حساب البائع أدناه ، وتأكد من ملاحظة الدفعة:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "إذا لم يتم إبداء ملاحظات في وقت الدفع ، فلن يتمكن البائع من تأكيد الدفع ، مما يؤدي إلى خسارة الأصول التي لا يمكن استردادها.",
  "未在规定的时间内付款，订单都将被取消。":
    "إذا لم يتم السداد في الوقت المحدد ، فسيتم إلغاء الطلب.",
  姓名: "اسم",
  收款姓名: "اسم المستفيد",
  开户支行: "فرع فتح الحساب",
  银行卡号: "رقم البطاقة المصرفية",
  "付款后，返回本平台": "بعد الدفع ، عد إلى هذه المنصة",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    'تأكد من النقر فوق الزر "لقد أكملت الدفع ، أبلغ البائع" أدناه',
  未点击卖家不会放款:
    'إذا لم تقم بالنقر فوق "النقر فوق" ، فلن يفرج البائع عن المال',
  交易条款: "شروط الصفقة",
  "购买资金来源，必须合法安全的资金，方可交易":
    "شراء مصدر الأموال ، يجب أن يكون لديك أموال قانونية وآمنة قبل أن تتمكن من التداول",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "لا يُسمح بالاحتيال أو المخططات الهرمية أو المقامرة أو غيرها من المعاملات المالية غير القانونية",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "بعد إتمام الصفقة ، هناك مخاطر من الأموال المجمدة أو المشتبه في وجودها الاحتيال والمخططات الهرمية وأموال المقامرة ، ولن نقوم بإصدار U للمشتري ، وسنقوم برد المبلغ.",
  "已付款，通知卖家": "المدفوعة ، إخطار البائع",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "إذا ألغى المشتري {0} من الطلبات في نفس اليوم ، فسيتم إلغاء وظيفة الشراء في نفس اليوم. هل أنت متأكد أنك تريد إلغاء هذا الطلب؟",
  添加收款方式: "إضافة طريقة الدفع",
  是否删除此收款方式: "ما إذا كان سيتم حذف طريقة الدفع هذه أم لا",
  删除: "حذف",
  请选择法币: "الرجاء تحديد العملة الورقية",
  机构名称: "اسم المعهد",
  请选择机构: "الرجاء تحديد مؤسسة",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "عندما تبيع عملة رقمية ، سيتم عرض طريقة الدفع التي حددتها للمشتري ، يرجى تأكيد أنها ملئت بشكل صحيح.",
  请选择银行: "الرجاء تحديد بنك",
  请输入姓名: "الرجاء كتابة اسمك",
  账号: "الحساب",
  请输入账号: "الرجاء إدخال الحساب",
  收款码: "رمز الاستلام",
  "银行账号/卡号": "رقم الحساب / البطاقة المصرفية",
  "请输入银行账号/卡号": "الرجاء إدخال رقم الحساب المصرفي / رقم البطاقة",
  "开户支行（选填）": "فرع فتح الحساب (اختياري)",
  请输入开户支行: "الرجاء إدخال فرع فتح الحساب",
  "加入*官方频道": "انضم {0} القناة الرسمية",
  关于: "حول",
  条款: "مصلحات",
  其他: "آخر",
  成功: "النجاح",
  等待: "انتظر",
  作废: "فارغ",
  确认付款: "تأكيد الدفع",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "هل تم السداد؟ إذا تم تأكيد الدفع ، فسيقوم التاجر بتأكيد ما إذا كان قد تم استلام الدفعة في غضون {0} دقائق.",
  最大金额: "الحد الأقصى للمبلغ",
  最小金额: "الحد الأدنى للمبلغ",
  付款: "دفع",
  法币充值: "إعادة شحن عملة فيات",
  法币提现: "سحب فيات",
  待支付: "لكي تدفع",
  已支付: "مدفوع",
  商户名: "تاجر",
  当前没有添加支付方式: "لا توجد طرق دفع مضافة حاليا",
  添加后再出售: "أضف للبيع",
  新人大礼包: "هدية الوافد الجديد",
  注册即可领取: "سجل ليصلك",
  立即领取: "احصل عليه الآن",
  不再提示: "لا تذكر مرة أخرى",
  "该奖励需在APP中领取，请下载APP":
    "يجب جمع المكافأة في التطبيق ، يرجى تنزيل التطبيق",
  去交易: "تجارة",
  期权交易: "تداول الخيارات",
  交易额: "قيمة التحويل",
  可用额度: "الحصة المتوفرة",
  交易周期: "دورة التداول",
  看涨: "ترتفع",
  看跌: "يسقط",
  当前持有: "المقتنيات الحالية",
  胜率: "معدل الفوز",
  "盈利/亏损数": "خسارة الأرباح",
  累计实现盈亏: "الأرباح والخسائر المتراكمة",
  秒: "ثواني",
  分: "اللحظة",
  小时: "ساعة",
  天: "أيام",
  周: "أسبوع",
  下单时间: "وقت الطلب",
  剩余时间: "الوقت المتبقي",
  买入价: "سعر الشراء",
  结算价: "سعر التسوية",
  实现盈利: "ربح",
  结算时间: "وقت التسوية",
  期权: "والخيارات",
  新手教程: "البرنامج التعليمي للمبتدئين",
  我的订单: "ترتيب",
  赔率: "احتمال",
  全部订单: "جميع الطلبات",
  持有订单: "عقد الأمر",
  历史订单: "تاريخ الطلب",
  输入交易额度: "أدخل المبلغ",
  选择交易周期: "فترة الاختيار",
  去注册: "يسجل",
  冻结: "تجميد",
  期权支出: "دفع تعويضات الخيار",
  期权收入: "دخل الخيار",
  用户提现: "سحب المستخدم",
  "是否购买？": "هل تريد ان تشتري؟",
  购买成功: "شراء ناجح",
  请签名: "لو سمحت وقع",
  提交签名: "تقديم التوقيع",
  清空签名: "توقيع واضح",
  签名审核中: "مراجعة التوقيع",
  已提交: "مُقَدَّم",
  扫一扫下载APP: "مسح وتنزيل التطبيق",
  新手领取大礼包: "نوبي تلقي فورةe",
  注册实名即送彩金: "مكافأة التسجيل والاسم الحقيقي",
  交易总额: "إجمالي الصفقة",
  资产不足: "أصول غير كافية",
  "Win账户的资产不足，可从现货账户划转至此账户":
    "الأصول الموجودة في حساب Win غير كافية ويمكن نقلها من حساب التمويل إلى هذا الحساب",
  Win: "Win",
  在线充值: "إعادة الشحن عبر الإنترنت",
  比赛: "منافسة",
  未开始: "لم يبدأ",
  赛程: "برنامج",
  赛果: "نتيجة",
  已结束: "على",
  让球: "Asian handicap",
  进球数: "Over/Under",
  大: "Over",
  小: "Under",
  胜负平: "Win/Lose",
  和局: "لعبة تعادل",
  投注: "الرهان",
  下注金额: "مبلغ الرهان",
  下注: "الرهان",
  阵容: "مجموعة المعركة",
  分析: "حلل",
  输入下注金额: "يدخل",
  下注成功: "رهان ناجح",
  投注记录: "سجل الرهان",
  未结算: "لا تسوية",
  已结算: "تسوية",
  流水: "مقدار",
  输赢: "الفوز أو الخسارة",
  赛时: "وقت اللعب",
  下注时间: "وقت الرهان",
  足彩竞猜: "مسابقة كرة القدم",
  查看详情: "يفحص",
  输: "تخسر",
  赢: "فوز",
  主: "فريق المنزل",
  客: "الفريق الضيف",
  主胜: "الفريق المضيف يفوز",
  客胜: "الفريق الضيف يفوز",
  平: "مسحوب",
  已延期: "مؤجل",
  账号异常: "استثناء الحساب",
  全场独赢: "1x2",
  全场让球: "Handicap",
  全场大小: "Over/Under",
  总进球: "إجمالي الأهداف",
  拍摄照片要求: "متطلبات الصورة",
  标准拍摄: "لقطة قياسية",
  边框缺失: "الحد مفقود",
  照片模糊: "الصورة ضبابية",
  闪光强烈: "فلاش قوي",
  上传手持证件照: "تحميل المستندات المحمولة باليد",
  上传证件照: "تحميل صورة الهوية",
  换一张: "تغيير واحد",
  出生日期: "تاريخ الولادة",
  请选择出生日期: "الرجاء تحديد تاريخ الميلاد",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "بعد إدخال التحقق الرسومي الصحيح أدناه ، احصل على رمز التحقق عبر البريد الإلكتروني للتسجيل",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "لديك {0} شهادة متبقية ، وبعد ذلك لن تتمكن من متابعة الاعتماد",
  上半场: "النصف الاول",
  下半场: "النصف الثاني",
  独赢: "1x2",
  上半场独赢: "1x2 النصف الاول",
  下半场独赢: "1x2 النصف الثاني",
  上半场让球: "Handicap النصف الاول",
  下半场让球: "Handicap النصف الثاني",
  上半场大小球: "Over/Under النصف الاول",
  下半场大小球: "Over/Under النصف الثاني",
  波胆: "Correct Score",
  上半场波胆: "Correct Score النصف الاول",
  下半场波胆: "Correct Score النصف الثاني",
  单双: "Odd/Even",
  上半场单双: "Odd/Even النصف الاول",
  下半场单双: "Odd/Even النصف الثاني",
  单: "Odd",
  双: "Even",
  总进球: "Total Goal",
  上半场总进球: "Total Goal النصف الاول",
  下半场总进球: "Total Goal النصف الثاني",
  中场: "خط الوسط",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "ملاحظة: يرجى اتباع هذه الصورة النموذجية لكتابة نص على ورقة بيضاء والتقاط الصورة ببطاقة الهوية",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "في الآونة الأخيرة ، تم اكتشاف عدد كبير من حسابات الغش ، وتمت معاقبة عدد من الحسابات غير القانونية. إذا كان هناك خطأ في التقدير على أنه حساب غير قانوني ، فيرجى الاتصال بخدمة العملاء عبر الإنترنت.",
  最小下注金额: "الحد الأدنى لمبلغ الرهان",
  参与活动最小下注金额: "الحد الأدنى لمبلغ الرهان للمشاركة في الحدث",
  记住密码: "تذكر كلمة المرور",
  比分: "نتيجة",
  "您还未登录，请先登录": "الرجاء تسجيل الدخول",
  立即登录: "تسجيل الدخول",
  下注限额: "حد الرهان",
  可赢金额: "قادر على الفوز",
  闪兑详情: "تفاصيل الفلاش",
  大小球: "Over/Under",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "بسبب سعر الصرف ، سيكون هناك فرق بين مبلغ الرهان ومبلغ الرهان الفعلي ، يرجى الرجوع إلى الأمر.",
  开赛时间: "وقت البدء",
  足球收入: "دخل كرة القدم",
  足球支出: "إنفاق كرة القدم",
  活动详情: "تفاصيل النشاط",
  为世界杯喝彩: "تحياتي لكأس العالم",
  我的竞猜: "لي",
  "竞猜比赛、有机会瓜分*USDT": "USDTخمن اللعبة واحصل على فرصة لمشاركة {0} ",
  "瓜分*USDT": "USDTمشاركة {0}",
  距离活动结束还有: "نهاية المسافة",
  我的门票: "تذكرتي",
  竞猜结束时间: "تخمين وقت الانتهاء",
  猜比分: "احزر النتيجة",
  "福利派送中，完成任务即可获取门票":
    "جارٍ توزيع الرفاهية ، أكمل مهمة الحصول على التذاكر",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "أكمل المهام التالية ، يمكنك الحصول على العدد المقابل من التذاكر للمشاركة في المسابقة",
  时: "ساعة",
  活动: "نشاط",
  竞猜记录: "سجل التخمين",
  结果: "نتيجة",
  任务: "مهمة",
  去邀请: "يدعو",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "في كل مباراة ، يمكنك الحصول على مكافأة قدرها { 0 } .",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "تتطلب المشاركة في الاختبار تذاكر يمكن الحصول عليها وفقًا لمهام المنصة.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的现货账户，你可以立即提取。":
    "بعد نجاح المسابقة ، إرسال لقطة من نتائج المسابقة إلى خدمة العملاء ، خدمة العملاء سوف تكون مكافأة في حساب رأس المال الخاص بك ، يمكنك سحب على الفور .",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "أي غش محظور ، وستكون المكافآت باطلة في حالة وجود غش.",
  "完成任务后，点击咨询客服获得门票。":
    "بعد الانتهاء من المهمة ، انقر فوق استشارة خدمة العملاء للحصول على التذكرة.",
  继续猜: "استمر في التخمين",
  总单数: "مجموع المفرد",
  赛事筛选: "فحص الحدث",
  球队筛选: "اختيار الفريق",
  总金额: "مبلغ مقطوع",
  总流水: "إجمالي دوران",
  派奖金额: "مبلغ المكافأة",
  下注单数: "الرهان على رقم فردي",
  利润: "ربح",
  更多福利: "خير",
  我的奖金: "مكافأتي",
  未认证: "غير معتمد",
  总量: "المجموع",
  或: "أو",
  模拟交易: "تداول تجريبي",
  体验账户不可操作: "حساب الخبرة غير قابل للتشغيل",
  世界杯比分竞猜: "مسابقة نتيجة كأس العالم",
  "领*USDT起": "USDTمن {0}",
  消息: "معلومة",
  滚球: "الكرة المتداول",
  是: "حق .",
  不是: "لا .",
  当前余额: "الرصيد الحالي",
  KOL招募: "التوظيف KOL",
  本月净输赢: "صافي ربح / خسارة الشهر",
  本月佣金: "عمولة الشهر",
  佣金比例: "نسبة العمولة",
  活跃人数: "رقم نشط",
  新增下级: "إضافة المرؤوس",
  登录人数: "عدد مرات تسجيل الدخول",
  首存人数: "عدد المودعين الأوائل",
  数据分析: "تحليل البيانات",
  人数: "عدد الاشخاص",
  新注册存款金额: "مبلغ الإيداع المسجل الجديد",
  老用户存款金额: "مبلغ الإيداع القديم للمستخدم",
  首存金额: "مبلغ الإيداع الأول",
  快捷入口: "دخول سريع",
  成员管理: "إدارة الأعضاء",
  财务报表: "القوائم المالية",
  分红报表: "تقرير توزيعات الأرباح",
  订单记录: "سجل الطلب",
  VIP专享: "VIP حصري",
  推广工具: "أداة الترويج",
  计算规则: "قواعد الحساب",
  账变明细: "تفاصيل تغيير الحساب",
  成员: "عضو",
  下级概览: "نظرة عامة على المرؤوسين",
  下级成员总计: "مجموع الأعضاء المرؤوسين",
  本月新增: "جديد هذا الشهر",
  本月活跃会员: "عضو نشط في الشهر",
  今日活跃会员: "الأعضاء النشطين اليوم",
  本月有效活跃: "نشط هذا الشهر",
  活跃成员占比: "نسبة الأعضاء النشطين",
  本月活跃: "نشط هذا الشهر",
  今日活跃: "نشط اليوم",
  下级成员: "عضو مبتدئ",
  会员账号: "حساب العضو",
  统计时间: "وقت الإحصاء",
  筛选: "منقي",
  存款: "الوديعة",
  取款: "سحب المال",
  总输赢: "مجموع الفوز أو الخسارة",
  是否有效用户: "هل هو مستخدم صالح",
  最近登录时间: "آخر وقت لتسجيل الدخول",
  否: "لا",
  开始时间: "وقت البدء",
  结束时间: "وقت النهاية",
  提取: "استخراج",
  总盈亏: "إجمالي الربح والخسارة",
  净盈亏: "صافي الربح والخسارة",
  分红: "أرباح",
  概览: "نظرة عامة",
  月度详细数据: "بيانات شهرية مفصلة",
  未发放: "لم يصدر",
  活跃用户: "مستخدم نشط",
  有效新增会员: "إضافة أعضاء جدد بشكل فعال",
  冲正后净输赢: "صافي الربح أو الخسارة بعد التنظيف",
  上月结余: "رصيد الشهر الماضي",
  净输赢: "صافي الربح / الخسارة",
  "系统每日新加坡时间1:00更新一次报表":
    "تقرير تحديث النظام في الساعة 1 : 00 بتوقيت سنغافورة",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "تشير الأرقام الموجبة في البيانات وإجمالي المكاسب والخسائر وصافي الأرباح والخسائر في التقرير إلى ربح الوكيل ، بينما تشير الأرقام السالبة إلى خسارة الوكيل",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "يتم تحديث بيانات العمولة كل يوم وهي للإشارة فقط ، وليس معيار توزيع العمولات الفعلي",
  选择时间: "فترة الاختيار",
  足球: "كرة القدم",
  投注金额: "مبلغ الرهان",
  有效订单: "أمر صالح",
  下级账户: "حساب ثانوي",
  待成交: "صفقة معلقة",
  下单金额: "كمية الطلب",
  订单内容: "ترتيب المحتوى",
  秒数: "ثواني",
  联赛: "الدوري",
  队伍: "فريق",
  比赛时间: "الوقت المتنافس",
  玩法: "كيف ألعب",
  等级规则表: "جدول مسطرة الصف",
  等级: "رتبة",
  活跃会员: "عضو نشط",
  最新活跃: "أحدث نشط",
  额外佣金: "عمولة اضافية",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "يتم تنفيذ معيار النمو ونظام المكافآت للمستوى المقابل كل شهر ، ويمكن الاستمتاع بمكافأة مستوى واحد فقط.",
  渠道生成: "قناة الجيل",
  创建: "خلق",
  渠道名称: "اسم القناة",
  注册人数: "عدد المسجلين",
  浏览人数: "مشاهدون",
  构建状态: "بناء الوضع",
  禁用: "معاق",
  启用: "ممكن",
  查看: "يفحص",
  创建渠道: "إنشاء قناة",
  创建成功: "تم إنشاؤها بنجاح",
  操作成功: "عملية ناجحة",
  渠道详情: "تفاصيل القناة",
  邀请码: "شفرة الدعوة",
  访问人数: "عدد الزوار",
  渠道地址: "عنوان القناة",
  我的福利: "الفوائد الخاصة بي",
  充值福利: "فوائد إعادة الشحن",
  当前流水: "تدفق التيار",
  如何参与: "كيفية المشاركة",
  币种充值: "إعادة شحن العملة",
  充值福利中领取福利: "احصل على مزايا من مزايا زيادة الرصيد",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "القواعد: ميزة إعادة الشحن اختيارية للاستلام ، وتكون فترة الصلاحية في غضون 24 ساعة بعد إعادة الشحن. ستكون غير صالحة بعد تاريخ انتهاء الصلاحية. بعد استلامها ، سيتم قفل وظيفة السحب النقدي مؤقتًا ، ويمكن أن يكون السحب النقدي مقفلة بعد الوصول إلى معدل دوران.",
  失效日期: "تاريخ الإنتهاء",
  "暂无福利领取，充值后领取": "لا توجد فوائد لتلقيها بعد إعادة الشحن",
  参与: "مشاركة",
  充值赠送: "هدية إعادة الشحن",
  "领取*%的赠送": "احصل على هدية {0}٪",
  去领取: "لجمع",
  VIP奖励: "مكافآت VIP",
  "当前可领取*USDT，是否确认领取":
    "يمكنك الحصول على {0} USDT في الوقت الحالي ، هل تؤكد المطالبة؟",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "بعد المطالبة ، سيتم قفل وظيفة السحب مؤقتًا ، ويمكن فتح القفل عندما يصل حجم مبيعاتك إلى {0} USDT",
  充值送大礼: "قم بتعبئة رصيدك لتحصل على هدية كبيرة",
  "存入越多，送越多！": "كلما قمت بإيداع أكثر ، كلما حصلت على المزيد!",
  无效: "غير صالحة",
  有效: "فعال",
  总存金额: "إجمالي مبلغ الإيداع",
  提示: "ملحوظة",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "تشير الأرقام الموجبة في إجمالي المكاسب والخسائر وصافي المكاسب والخسائر إلى أرباح المنصة ، بينما تشير الأرقام السالبة إلى الخسائر. البيانات اليومية هي للإشارة فقط ولا تعمل كمعيار فعلي لتوزيع العمولات.",
  "净盈亏：总盈亏-用户返水":
    "صافي الربح والخسارة: إجمالي الربح والخسارة - خصم المستخدم",
  盈利方: "حفلة مربحة",
  代理: "التمثيل",
  客户: "عميل",
  平局: "رسم",
  平台: "برنامج",
  "已提交审核，请耐心等待": "قدم للمراجعة ، يرجى التحلي بالصبر",
  充值日期: "تاريخ الشحن",
  平台本月总输赢: "إجمالي انتصارات وخسائر المنصة هذا الشهر",
  KOL招募合作: "التعاون في التوظيف KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "المنصة مفتوحة الآن [KOL Recruitment Event] ، طالما كان لديك حساب على وسائل التواصل الاجتماعي ، يمكنك الاستمتاع بمكافأة لمرة واحدة مع النظام الأساسي للترويج للعملاء ، ويمكنك الاستمتاع بمزايا مدى الحياة.",
  级别: "مستوى",
  平台利润返佣: "خصم ربح المنصة",
  佣金案例: "حالة العمولة",
  交易项目: "بند الصفقة",
  "期权交易、合约交易、足球游戏":
    "تداول الخيارات ، العقود التجارية ، ألعاب كرة القدم",
  报名方式: "طرق التسجيل",
  点击KOL招募报名: "انقر فوق تسجيل التوظيف في KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "مرحبًا بك للانضمام إلى فريقنا ، النظام الأساسي يدعمك تمامًا لإنشاء نظام المستخدم الخاص بك ، ويمكنك الحصول على أعلى عمولة {0} ، ونتطلع إلى انضمامك.",
  输入联系方式: "أدخل معلومات الاتصال",
  最低活跃人数: "الحد الأدنى للرقم النشط",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "على سبيل المثال: عدد المستخدمين النشطين هذا الشهر ≥ {0} وإجمالي ربح أو خسارة النظام الأساسي هذا الشهر ≥ {1} USDT ، أنت تنتمي إلى المستوى {3} ، يمكنك الحصول على {2}٪ عمولة.",
  比分竞猜: "درجة التخمين",
  豪礼相赠: "هدية",
  足球活动: "نشاط كرة القدم",
  圣诞节活动: "أنشطة عيد الميلاد",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "كنت قد شاركت في هذا الحدث ، مؤقتا قفل ميزة استخراج ، تحتاج أيضا إلى { 0 } usdt خط أنابيب لفتح القفل .",
  剩余流水: "تدفق المتبقية",
  助力足球: "مساعدة كرة القدم",
  佣金累计: "العمولة الإجمالية",
  有效投注: "رهان صالح",
  今日: "اليوم",
  今日返水: "خصم اليوم",
  VIP返水: "خصم VIP",
  返水记录: "سجل الخصم",
  成员信息: "معلومات الاعضاء",
  基本信息: "معلومات اساسية",
  钱包余额: "رصيد المحفظة",
  投注信息: "معلومات الرهان",
  返水: "خصم",
  总下注: "الرهان الكلي",
  今日输赢: "الفوز أو الخسارة اليوم",
  下注动态: "ديناميكيات الرهان",
  返水奖励: "مكافأة الخصم",
  分红金额: "مبلغ التوزيعات",
  返水支出: "دفع تعويضات الخصم",
  总返水: "إجمالي الخصم",
  流水总额: "إجمالي حجم التداول",
  返水总额: "إجمالي الحسم",
  返水详情: "تفاصيل الخصم",
  日流水: "ماء يومي",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "توفر المنصة مكافآت خصم إضافية بناءً على معدل التداول اليومي لمرؤوسك ، وسيتم توزيع المكافآت على حساب المكافأة في تمام الساعة 00:00 بتوقيت سنغافورة كل يوم",
  "申请成功，等待审核": "التطبيق ناجح ، في انتظار المراجعة",
  "我出本金，盈利共分享": "أنا أدفع رأس المال وأشارك في الأرباح",
  最高分红: "أعلى عائد",
  投资大师比赛: "مسابقة ماجستير الاستثمار",
  "我出本金，你盈利": "أنا أدفع رأس المال ، أنت ربح",
  共分享: "مشترك",
  最高分红可得: "أقصى توزيعات الأرباح المتاحة",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "مزايا حصرية للمستخدمين الجدد قادمة ، مجانية {0} دولار ، يمكنك الاستثمار في أي مشروع على المنصة بعد استلامه ، ويمكنك سحبه فورًا بعد تحقيق ربح.",
  报名领取: "اشترك لتلقي",
  已领取: "الواردة",
  审核驳回: "مراجعة مرفوضة",
  驳回原因: "سبب الرفض",
  活动运行周期: "دورة تشغيل النشاط",
  "申请成功后起至*天内完成超额收益。":
    "بعد نجاح التطبيق ، سيتم إكمال الدخل الزائد في غضون {0} أيام.",
  分红比: "نسبة توزيعات الأرباح",
  "*日获得盈利后，可获得*%的收益额。":
    "بعد جني الأرباح في اليوم {0} ، يمكنك الحصول على {1}٪ من الربح.",
  参与条件: "شروط المشاركة",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "لم يشارك المستخدمون في روسيا وتركيا.",
  计算项目: "عنصر الحساب",
  "合约、体育、期权": "عقود ، رياضة ، خيارات",
  我的投资: "استثماري",
  参与天数: "أيام المشاركة",
  累计下注: "الرهان التراكمي",
  累计盈亏: "الأرباح والخسائر المتراكمة",
  预计可分红: "من المتوقع أن تدفع توزيعات الأرباح",
  常见问题: "مشكلة شائعة",
  什么是平台出资: "ما هو تمويل المنصة",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "وفقًا للمستخدمين في بعض البلدان ، توفر المنصة أموالًا مجانية للمستخدمين للاستثمار في المشاريع.",
  怎么获取平台出资的福利: "كيفية الحصول على فوائد مساهمة المنصة",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "ما عليك سوى أن تكون مستخدمًا في بلد معين ، انقر فوق زر التسجيل أعلاه ، وسيتم تحويل {0} USDT إلى حساب المكافأة ضمن الحساب الجاري بعد اكتمال مراجعة النظام الأساسي ، ويمكنك تحويله إلى حسابات أخرى للاستثمار.",
  什么是分红: "ما هو العائد",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "يعني توزيع الأرباح أنه خلال فترة زمنية محددة ، بعد وصول الدخل إلى 100٪ ، يمكن توزيع 50٪ من الدخل الزائد. على سبيل المثال: لتلقي أموال بقيمة 100 دولار أمريكي ، يكون مبلغ الدخل 120٪.",
  "如何取得分红？": "كيف تحصل على أرباح الأسهم؟",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "تكون دورة النشاط مرة واحدة كل يوم {0}. بعد انتهاء النشاط ، سيتم احتسابها ، وسيتم توزيع أرباح الأسهم على حساب المكافأة بعد تلبية متطلبات النشاط. إذا لم تستوفِ متطلبات النشاط ، فسيقوم النظام تلقائيًا بمسح دخلك ومساهمات النظام الأساسي.",
  活动规则: "قواعد النشاط",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    'يجب أن تخضع الحسابات المشاركة لعملية التحقق من "اعرف عميلك" ، ويقتصر كل حساب على ميزة واحدة.',
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    'يتطلب "اعرف عميلك" (KYC) للحسابات المشاركة مشاركة الدولة المحددة ، كما أن المناطق الأخرى غير مصرح لها بالمشاركة. يرجى التحقق مما إذا كانت الدولة النشطة متوافقة مع بلدك.',
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "بعد المشاركة بنجاح في النشاط ، سيقوم الحساب بإغلاق وظيفة السحب مؤقتًا ، وسيتم تحرير وظيفة السحب بعد اكتمال النشاط.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "يرجى الالتزام بقواعد نشاط المنصة. إذا وجدت غشًا أو استغلال ثغرات في النظام من أجل الربح ، فسيقوم النظام الأساسي بتجميد جميع الأموال الموجودة في حسابك لفترة طويلة.",
  平台出资: "منصة الاستثمار",
  平台出资收回: "استعادة استثمار المنصة",
  投资大师奖励: "جائزة ماجستير الاستثمار",
  请下载APP添加收款方式: "يرجى تنزيل التطبيق لإضافة طريقة دفع",
  请下载APP进行身份验证: "يرجى تنزيل التطبيق للتحقق من الهوية",
  请下载APP参与: "يرجى تنزيل التطبيق للمشاركة",
  技术指标: "المؤشرات الفنية",
  主图: "الصورة الرئيسية",
  副图: "الصورة الفرعية",
  新注册人数: "المسجلين الجدد",
  老用户存款人数: "ودائع المستخدم القديم",
  存款人数: "عدد المودعين",
  取款人数: "عدد السحوبات",
  投注人数: "عدد المراهنين",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "باستثناء إندونيسيا والهند وبنغلاديش والمستخدمين الذين لم يشاركوا.",
  市场动态: "ديناميات السوق",
  外汇合约: "عقد الصرف الأجنبي",
  盈亏比: "نسبة الربح إلى الخسارة",
  委托价: "سعر الطلب",
  可用余额: "الرصيد المتوفر",
  持仓额: "مبلغ الموقف",
  强平价: "تكافؤ قوي",
  修改: "يراجع",
  修改价位: "تعديل السعر",
  外汇: "الفوركس",
  外汇账户: "حساب فوركس",
  我的交易: "معاملتي",
  未设置: "غير مضبوط",
  超出最大可设数值: "يتجاوز الحد الأقصى للقيمة القابلة للتعيين",
  超出最小可设数值: "يتجاوز الحد الأدنى للقيمة القابلة للتعيين",
  止盈超出最小可设数值: "جني الأرباح يتجاوز الحد الأدنى للقيمة القابلة للتسوية",
  止损超出最大可设数值: "يتجاوز وقف الخسارة الحد الأقصى للقيمة القابلة للتعيين",
  止盈超出最大可设数值: "جني الأرباح يتجاوز الحد الأقصى للقيمة القابلة للتسوية",
  止损超出最小可设数值: "يتجاوز وقف الخسارة الحد الأدنى للقيمة القابلة للتعيين",
  挖矿: "التعدين",
  交易账户: "حساب الصفقة",
  买涨: "يشتري",
  买跌: "شراء أو بيع",
  请输入正确的银行卡信息: "الرجاء إدخال معلومات البطاقة المصرفية الصحيحة",
  联系在线客服: "اتصل بخدمة العملاء عبر الإنترنت",
  法币交易请联系在线客服:
    "بالنسبة للمعاملات القانونية بالعملة، يرجى الاتصال بخدمة العملاء عبر الإنترنت",
  提交订单: "أكد الطلب",
  "支付过程如有疑问,请联系在线客服":
    "إذا كان لديك أي أسئلة حول عملية الدفع، يرجى الاتصال بخدمة العملاء عبر الإنترنت",
  彩金赠送: "هدية",
  在线客服: "خدمة الإنترنت",
  最少投资: "الحد الأدنى للاستثمار",
  "提交时间:": "وقت التقديم:",
  提现拒绝: "تم رفض الانسحاب",
  认证拒绝: "تم رفض المصادقة",
  认证通过: "مرت الشهادة",
  请输入正确的交易额度: "الرجاء إدخال مبلغ المعاملة الصحيح",
  最大下注金额: "الحد الأقصى لمبلغ الرهان",
  手机号: "رقم التليفون",
  邮箱注册: "تسجيل البريد الإلكتروني",
  手机号注册: "تسجيل رقم الهاتف المحمول",
  查询: "استعلام",
  手机号登录: "تسجيل الدخول برقم الهاتف المحمول",
  邮箱登录: "تسجيل الدخول بالبريد الإلكتروني",
  请输入数量: "الرجاء إدخال الكمية",
  可用数量: "الكمية متاحة",
  钱包登录: "تسجيل الدخول إلى المحفظة",
  请输入正确的邀请码: "الرجاء إدخال رمز الدعوة الصحيح",
  "请输入邀请码(必填)": "الرجاء إدخال رمز الدعوة (مطلوب)",
  输入正确的金额: "أدخل المبلغ الصحيح",
  法币充值: "إعادة الشحن بالعملة الوطنية",
  卢比充值: "إعادة شحن الروبية",
  请输入法币: "الرجاء إدخال العملة الأجنبية",
  请输入IFSC: "الرجاء إدخال IFSC",
  "银行编码(选填)": "رمز البنك (اختياري)",
  请输入银行编码: "الرجاء إدخال رمز البنك",
  请输入大于8位数的密码: "الرجاء إدخال كلمة مرور أكبر من 8 أرقام",
  添加成功: "اضيف بنجاح",
  "60秒": "60 ثانية",
  "180秒": "180 ثانية",
  "300秒": "300 ثانية",
  "2次密码不一致": "2 يوم من اليوم",
  输入提币数量: "أدخل مبلغ السحب",
  图片格式不正确: "تنسيق الصورة غير صحيح",
  图片大于20M: "حجم الصورة أكبر من 20 ميغابايت",
  请设置委托价格: "يرجى تعيين سعر التفويض",
  输入资金密码: "أدخل كلمة مرور الأموال",
  验证码错误: "خطأ في رمز التحقق",
  充值拒绝: "تم رفض إعادة الشحن",
  请输入SSN: "الرجاء إدخال رقم الضمان الاجتماعي",
  合约交易: "تداول العقود",
  结算完成: "اكتملت التسوية",
  继续下单: "متابعة الطلب",
  最低购买: "الحد الأدنى للشراء",
  最高购买: "أعلى عملية شراء",
  限价: "سعر الحد",
  买入价格: "سعر الشراء",
  买入量: "كمية الشراء",
  卖出价格: "سعر البيع",
  卖出量: "كمية البيع",
  买入: "شراء",
  卖出: "بيع",
  订单创建成功: "تم إنشاء الطلب بنجاح",
  币币买入支出: "تكلفة شراء العملات",
  币币买入支出退还: "إرجاع تكلفة شراء العملات",
  币币买入获得: "الحصول على العملات المشتراة",
  币币卖出支出: "تكلفة بيع العملات",
  币币卖出支出退还: "إرجاع تكلفة بيع العملات",
  币币卖出获得: "الحصول على العملات المباعة",
  币币交易手续费: "رسوم معاملة العملات",
  请输入限价: "يرجى إدخال سعر الحد",
  成交: "اكتمل",
  等待成交: "في انتظار الاكتمال",
  交易完成: "اكتملت المعاملة",
  被取消: "تم الإلغاء",
  交易时间: "وقت المعاملة",
  法币交易: "تداول العملات الورقية",
  法币出售: "بيع العملات الورقية",
  两次密码不一致: "كلمتا المرور غير متطابقتين",
  再次输入账户密码: "أعد إدخال كلمة مرور الحساب",

  美国: "الولايات المتحدة الأمريكية",
  韩国: "كوريا الجنوبية",
  阿尔巴尼亚: "ألبانيا",
  津巴布韦: "زيمبابوي",
  赞比亚: "زامبيا",
  也门: "اليمن",
  美属维尔京群岛: "جزر فيرجن الأمريكية",
  英属处女群岛: "جزر فيرجن البريطانية",
  越南: "فيتنام",
  委内瑞拉: "فنزويلا",
  瓦努阿图: "فانواتو",
  乌兹别克斯坦: "أوزبكستان",
  乌拉圭: "أوروغواي",
  英国: "المملكة المتحدة.",
  阿拉伯联合酋长国: "الإمارات العربية المتحدة",
  乌克兰: "أوكرانيا",
  乌干达: "أوغندا",
  特克斯和凯科斯群岛: "جزر الأتراك وكايكوس",
  土库曼斯坦: "تركمانستان",
  土耳其: "Türkiye",
  突尼斯: "تونس",
  特立尼达和多巴哥: "ترينيداد وتوباغو",
  汤加: "تونغا",
  多哥: "توغو",
  东帝汶: "تيمور-ليشتي",
  泰国: "تايلاند",
  坦桑尼亚: "تنزانيا",
  塔吉克斯坦: "طاجيكستان",
  中国台湾: "تايوان ، الصين",
  叙利亚: "سوريا",
  瑞士: "سويسرا",
  瑞典: "السويد",
  斯威士兰: "سوازيلاند",
  苏里南: "سورينام",
  苏丹: "السودان",
  斯里兰卡: "سري لانكا",
  西班牙: "إسبانيا",
  南非: "جنوب أفريقيا",
  索马里: "الصومال",
  所罗门群岛: "جزر سليمان",
  斯洛文尼亚: "سلوفينيا",
  斯洛伐克: "سلوفاكيا",
  "圣马丁岛（荷兰部分）": "سانت مارتن (جزء هولندا)",
  新加坡: "سنغافورة",
  塞拉利昂: "سيراليون",
  塞舌尔: "سيشيل",
  塞尔维亚: "صربيا",
  塞内加尔: "السنغال",
  沙特阿拉伯: "المملكة العربية السعودية",
  圣多美和普林西比: "ساو تومي وبرينسيبي",
  圣马力诺: "سان مارينو",
  萨摩亚: "ساموا",
  圣克里斯托弗和尼维斯: "القديس كريستوفر ونيفيس",
  圣文森特和格林纳丁斯: "القديس فنسنت وجرينادين",
  圣彼埃尔和密克隆岛: "سانت بيير وميكلون جزيرة",
  圣露西亚: "سانت لوسيا",
  圣基茨和尼维斯: "سانت كيتس ونيفيس",
  卢旺达: "رواندا",
  俄罗斯: "روسيا",
  罗马尼亚: "رومانيا",
  留尼汪: "جمع شمل",
  刚果共和国: "جمهورية الكونغو",
  卡塔尔: "قطر",
  波多黎各: "بورتوريكو",
  葡萄牙: "البرتغال",
  波兰: "بولندا",
  菲律宾: "الفلبين",
  秘鲁: "بيرو",
  巴拉圭: "باراجواي",
  巴布亚新几内亚: "بابوا غينيا الجديدة",
  巴拿马: "بنما",
  巴勒斯坦: "فلسطين",
  帕劳: "بالاو",
  巴基斯坦: "باكستان",
  阿曼: "عمان",
  挪威: "النرويج",
  尼日利亚: "نيجيريا",
  尼日尔: "النيجر",
  尼加拉瓜: "نيكاراغوا",
  新西兰: "نيوزيلندا",
  新喀里多尼亚: "كاليدونيا الجديدة",
  荷属安德列斯群岛: "هولندا أندريس جزر",
  荷兰: "هولندا",
  尼泊尔: "نيبال",
  纳米比亚: "ناميبيا",
  缅甸: "ميانمار",
  莫桑比克: "موزمبيق",
  摩洛哥: "المغرب",
  蒙特塞拉特岛: "جزيرة مونتسيرات",
  黑山: "الجبل الأسود",
  蒙古: "منغوليا",
  摩纳哥: "موناكو",
  摩尔多瓦: "مولدوفا",
  墨西哥: "المكسيك",
  马约特: "مايوت",
  毛里求斯: "موريشيوس",
  毛里塔尼亚: "موريتانيا",
  马里亚纳群岛: "جزر ماريانا",
  马提尼克: "مارتينيك",
  马耳他: "مالطا",
  马里: "مالي",
  马尔代夫: "جزر المالديف",
  马来西亚: "ماليزيا",
  马拉维: "ملاوي",
  马达加斯加: "مدغشقر",
  马其顿: "مقدونيا",
  中国澳门: "ماكاو ، الصين",
  卢森堡: "لوكسمبورغ",
  立陶宛: "ليتوانيا",
  列支敦士登: "ليختنشتاين",
  利比亚: "ليبيا",
  利比里亚: "ليبيريا",
  莱索托: "ليسوتو",
  黎巴嫩: "لبنان",
  拉脱维亚: "لاتفيا",
  老挝: "لاوس",
  吉尔吉斯斯坦: "قيرغيزستان",
  科威特: "الكويت",
  基里巴斯: "كيريباتي",
  肯尼亚: "كينيا",
  哈萨克斯坦: "كازاخستان",
  约旦: "الأردن",
  日本: "اليابان",
  牙买加: "جامايكا",
  象牙海岸: "ساحل العاج",
  意大利: "إيطاليا",
  以色列: "إسرائيل",
  爱尔兰: "أيرلندا",
  伊拉克: "العراق",
  伊朗: "إيران",
  印度尼西亚: "أندونيسيا",
  印度: "الهند",
  冰岛: "أيسلندا",
  匈牙利: "هنغاريا",
  中国香港: "هونغ كونغ ، الصين",
  洪都拉斯: "هندوراس",
  海地: "هايتي",
  圭亚那: "غيانا",
  几内亚比绍共和国: "جمهورية غينيا بيساو",
  几内亚: "غينيا",
  危地马拉: "غواتيمالا",
  关岛: "غوام",
  瓜德罗普岛: "غواديلوب",
  格林纳达: "غريدا",
  格陵兰岛: "غرينلاند",
  希腊: "اليونان",
  直布罗陀: "جبل طارق",
  加纳: "غانا",
  德国: "ألمانيا",
  格鲁吉亚: "جورجيا",
  冈比亚: "غامبيا",
  加蓬: "الجابون",
  法属波利尼西亚: "بولينيزيا الفرنسية",
  法属圭亚那: "غويانا الفرنسية",
  法国: "فرنسا",
  芬兰: "فنلندا",
  斐济: "فيجي",
  法罗群岛: "جزر فارو",
  埃塞俄比亚: "أثيوبيا",
  爱沙尼亚: "إستونيا",
  厄立特里亚: "إريتريا",
  赤道几内亚: "غينيا الاستوائية",
  萨尔瓦多: "السلفادور",
  埃及: "مصر",
  厄瓜多尔: "الإكوادور",
  多米尼加共和国: "جمهورية الدومينيكان",
  多米尼加: "الدومينيكان",
  吉布提: "جيبوتي",
  丹麦: "الدنمارك",
  捷克: "الجمهورية التشيكية",
  塞浦路斯: "قبرص",
  库拉索: "كوراكاو",
  古巴: "كوبا",
  克罗地亚: "كرواتيا",
  哥斯达黎加: "كوستاريكا",
  科特迪瓦: "كوت ديفوار",
  库克群岛: "كوك جزر",
  科摩罗: "COMOROS",
  哥伦比亚: "كولومبيا",
  智利: "تشيلي",
  乍得: "تشاد",
  中非共和国: "جمهورية وسط إفريقيا",
  佛得角: "كيب فيردي",
  开曼群岛: "جزر كايمان",
  开普: "كايبو",
  加拿大: "كندا",
  喀麦隆: "الكاميرون",
  柬埔寨: "كمبوديا",
  布隆迪: "بوروندي",
  布基纳法索: "بوركينا فاسو",
  保加利亚: "بلغاريا",
  文莱: "بروناي",
  巴西: "البرازيل",
  博茨瓦纳: "بوتسوانا",
  波斯尼亚和黑塞哥维那: "البوسنة والهرسك",
  玻利维亚: "بوليفيا",
  不丹: "بوتان",
  百慕大群岛: "جزر برمودا",
  贝宁: "بنين",
  伯利兹: "بليز",
  比利时: "بلجيكا",
  白俄罗斯: "بيلاروسيا",
  巴巴多斯: "بربادوس",
  孟加拉国: "بنغلاديش",
  巴林: "البحرين",
  巴哈马: "جزر البهاما",
  阿塞拜疆: "أذربيجان",
  奥地利: "النمسا",
  澳大利亚: "أستراليا",
  阿鲁巴: "أروبا",
  亚美尼亚: "أرمينيا",
  阿根廷: "الأرجنتين",
  安提瓜和巴布达: "أنتيغوا وبربودا",
  安圭拉: "أنغيلا",
  安哥拉: "أنغولا",
  安道尔: "أندورا",
  美属萨摩亚: "ساموا الأمريكية",
  阿尔及利亚: "الجزائر",
  中国: "الصين",

  日收益: "الربح اليومي",
  "30天预期收益": "الربح المتوقع لمدة 30 يوماً",
  英伟达高速矿机: "آلة تعدين NVIDIA عالية السرعة",
  去投资: "الذهاب للاستثمار",
  新币榜: "قائمة العملات الجديدة",
  主题: "الموضوع",
  立即探索: "استكشف الآن",
  等您来: "ننتظرك",
  最新活动: "آخر الأنشطة",
  货币划转: "تحويل العملات",
  提现钱包: "محفظة السحب",
  加密合约: "عقد التشفير",
  外汇期货: "عقود الأوراق المالية المستقبلية للعملات الأجنبية",
  定期: "محدد الأجل",
  探索产品: "استكشاف المنتجات",
  稳健型: "النوع المستقر",
  高收益: "عالي العائد",
  期货账户: "حساب العقود المستقبلية",
  时间线: "المخطط الزمني",
  收藏: "المفضلة",
  委托订单: "طلب التعهد",
  最新交易: "آخر الصفقات",
  深度图: "مخطط العمق",
  标记价格: "سعر العلامة",
  "24h最高价": "أعلى سعر في 24 ساعة",
  "24h成交量": "حجم التداول في 24 ساعة",
  "24h最低价": "أدنى سعر في 24 ساعة",
  "24h成交额": "قيمة التداول في 24 ساعة",
  "价格(USDT)": "السعر (يورو)",
  "数量(ETH)": "الكمية (إيثيريوم)",
  看空: "توقع انخفاض السعر",
  余额不足: "رصيد غير كافٍ",
  最低购买: "الحد الأدنى للشراء",
  最高购买: "الحد الأقصى للشراء",
  下单成功: "تم تقديم الطلب بنجاح",
  平仓成功: "تم إغلاق المركز بنجاح",
  请输入正确的平仓数量: "يرجى إدخال الكمية الصحيحة لإغلاق المركز",
  加仓成功: "تم زيادة حجم المركز بنجاح",
  请输入正确的加仓金额: "يرجى إدخال المبلغ الصحيح لزيادة حجم المركز",
  收藏成功: "تمت الإضافة إلى المفضلة بنجاح",
  取消收藏成功: "تم إزالة من المفضلة بنجاح",
  日收益率: "معدل العائد اليومي",
  轻松理财: "إدارة المال بسهولة",
  立即申购: "اشترك الآن",
  申购日期: "تاريخ الاشتراك",
  加密货币: "العملات المشفرة",
  交割合约: "عقد التسليم",
  最小投资: "الحد الأدنى للاستثمار",
  委托: "التعهد",
  "当指数价格触达时，将会触发委托平仓":
    "عند الوصول لسعر المؤشر، سيتم تشغيل إغلاق المركز التعهدي",
  预计盈利: "الربح المتوقع",
  最大投资: "الحد الأقصى للاستثمار",
  现货交易: "تداول العملات الرقمية",
  输入交易金额: "أدخل مبلغ الصفقة",
  "可用额度：": "الحدود المتاحة:",
  提现货币: "عملة السحب",
  期货合约: "عقد الأوراق المالية المستقبلية",
  加密币永续: "عقود دائمة للعملات المشفرة",
  外汇永续: "عقود دائمة للفوركس",
  期权账户: "حساب الخيارات",
  夜间模式: "الوضع الليلي",
  未结盈亏: "الأرباح والخسائر غير المسددة",
  超额收益: "فائض الدخل",
  "安全策略，低买高卖": "استراتيجية الأمن ، وانخفاض شراء وبيع عالية",
  投资金额应为: "مبلغ الاستثمار",
  总收益率: "إجمالي العائد",
  赎回成功: "الخلاص بنجاح",
  快捷卖币: "بيع سريع",
  修改止盈止损: "تعديل جني الأرباح/وقف الخسارة",
  白皮书: "ورقة بيضاء",

  托管资金: "الأموال المودعة",
  托管中: "قيد الإدارة",
  预计日收益: "العائد اليومي المتوقع",
  累计收益: "إجمالي الأرباح",
  周期: "الفترة",
  日收益: "العائد اليومي",
  限额: "الحد الأقصى",
  立即托管: "إيداع فوري",
  "已鎖定 請聯繫客服": "مقفل، يرجى التواصل مع خدمة العملاء",
  产品列表: "قائمة المنتجات",
  规则: "القواعد",
  创建订单: "إنشاء طلب",
  产品名称: "اسم المنتج",
  托管周期: "فترة الإيداع",
  等级限制: "قيود المستوى",
  托管金额: "مبلغ الإيداع",
  限额: "الحد الأقصى",
  余额: "الرصيد",
  购买日: "تاريخ الشراء",
  起息日: "تاريخ بدء الفائدة",
  派息时间: "وقت توزيع الأرباح",
  每天: "يومياً",
  计息结束日: "تاريخ انتهاء الفائدة",
  每日收益: "العائد اليومي",
  预计收益: "العائد المتوقع",
  "收益将自动发送至您的余额账户;":
    "سيتم إرسال الأرباح تلقائياً إلى حساب رصيدك;",
  "您的资金没有任何风险;": "أموالك لا توجد بها أي مخاطر;",
  "365*24小时不断地工作;": "يعمل 24 ساعة طوال 365 يومًا;",
  托管中: "قيد الإدارة",
  结束: "انتهى",
  今日收益: "أرباح اليوم",
  剩余周期: "الفترة المتبقية",
  进行中: "قيد التنفيذ",
  已发放: "تم الصرف",
  信誉分: "نقاط السمعة",
  复制成功: "تم النسخ بنجاح",
  VIP权益: "مزايا VIP",
  旧密码: "كلمة المرور القديمة",
  请输入旧密码: "الرجاء إدخال كلمة المرور القديمة",
  "忘记旧密码请联系客服重置。":
    "إذا نسيت كلمة المرور القديمة، يرجى الاتصال بخدمة العملاء لإعادة تعيينها.",
  去升级: "الترقية الآن",
  描述: "الوصف",
  实际存款金额: "مبلغ الإيداع الفعلي",
  升级礼金: "مكافأة الترقية",
  隔夜利息: "فائدة التبييت",
  自动结算: "التسوية التلقائية",
  等级规则: "قواعد المستوى",
  "WEB3.0币持有数据收益": "عائد بيانات الاحتفاظ بعملات WEB3.0",
  总生产: "الإنتاج الإجمالي",
  有效节点: "العقد النشطة",
  参与人: "المشاركون",
  用户收益: "أرباح المستخدم",
  "流动性WEB3.0输出": "إنتاج سيولة WEB3.0",
  总资产: "إجمالي الأصول",

  ETHAI持有数据收益: "عوائد بيانات حيازة ETHAI",
  AI量化流动性: "سيولة الذكاء الاصطناعي الكمية",
  现货买入手续费: "رسوم شراء الفوري",
  现货支出: "مدفوعات الفوري",
  现货资金费率: "سعر تمويل الفوري",
  现货卖出手续费: "رسوم بيع الفوري",
  现货收入: "إيرادات الفوري",
  外汇合约支出: "مدفوعات عقود العملات الأجنبية",
  外汇合约买入手续费: "رسوم شراء عقود العملات الأجنبية",
  外汇合约资金费率: "سعر تمويل عقود العملات الأجنبية",
  外汇合约卖出手续费: "رسوم بيع عقود العملات الأجنبية",
  外汇合约收入: "إيرادات عقود العملات الأجنبية",
  理财购买: "شراء المنتجات المالية",
  VIP理财日收益: "عائد يومي لمنتج VIP المالي",
  VIP理财隔夜利息: "فائدة ليلة واحدة لمنتج VIP المالي",
  VIP本金返还: "استرداد أصل المال لـ VIP",
  VIP彩金发放: "صرف مكافأة VIP",
  VIP彩金抵扣: "خصم مكافأة VIP",
  隔夜利息: "فائدة التبييت",
  设置资产密码: "تعيين كلمة مرور الأصول",

  锁仓挖矿: "التعدين المقفل",
  一站式理财服务: "خدمة مالية شاملة",
  产品: "المنتجات",
  客服中心: "مركز خدمة العملاء",
  贷款: "القروض",
  挖矿赚不停: "اربح باستمرار من التعدين",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "يتم التعدين المقفل من خلال إيداع USDT ‏(USD:1USDT=1USD) في أجهزة التعدين فائقة القدرة التابعة للمنصة لتحقيق أرباح التعدين من مجمع التعدين الخاص بالمنصة.",
  产品优势: "مزايا المنتج",
  随存随取: "إيداع وسحب مرن",
  锁仓周期: "فترة القفل",
  每日下发: "توزيع يومي",
  随机空投: "إيردروب عشوائي",
  "100%资金安全保障": "ضمان أمان الأموال بنسبة 100%",
  "100%节假日收益不间断": "الأرباح مستمرة 100% حتى في العطلات",
  成功锁仓后当天产出: "يبدأ الإنتاج في نفس يوم القفل الناجح",
  关于违约金: "حول رسوم الإخلال",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "إذا كنت ترغب في سحب رأس المال قبل موعد الاستحقاق، سيتم فرض رسوم إخلال. رسوم الإخلال = نسبة تسوية الإخلال × الأيام المتبقية × مبلغ القفل.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "مثال: نسبة تسوية الإخلال لهذا التعدين المقفل هي 5%، والمتبقي 3 أيام حتى الاستحقاق، ومبلغ القفل 10000U ‏(USDT/USD)، إذن رسوم الإخلال = ‎5%×3×10000=1500U، وسيتم إرجاع رأس مال فعلي قدره 15000U-1500U.",
  收益计算: "حساب الأرباح",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "توفر المنصة عدة منتجات مالية للتعدين المقفل للمستخدمين، ويتم حساب الأرباح كما يلي، مثال:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "إذا قام العضو بقفل 10000U ‏(USDT,USD) في المنصة واختار منتجًا ماليًا لمدة 7 أيام بعائد يومي يتراوح بين 0.7%~1.8% من مبلغ القفل، فسيكون العائد اليومي كما يلي:",
  "最低:10000Ux0.7%=70U;": "الحد الأدنى: 10000U×0.7%=70U;",
  "最高:10000Ux1.8%=180U;": "الحد الأقصى: 10000U×1.8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "أي أنه بعد 7 أيام يمكن الحصول على أرباح تتراوح بين 490U~1260U، ويتم توزيع الأرباح يوميًا، وبعد انتهاء مدة القفل يتم تحويل رأس المال تلقائيًا إلى حسابك المالي.",
  正在托管的资金: "الأموال قيد الإدارة",
  签到: "تسجيل الدخول اليومي",
  锁仓订单: "طلبات القفل",
  预计今日收益: "الأرباح المتوقعة اليوم",
  累计收益: "إجمالي الأرباح",
  托管中的订单: "الطلبات قيد الإدارة",
  单笔最少: "الحد الأدنى للطلب",
  单笔最多: "الحد الأقصى للطلب",
  日收益率: "معدل العائد اليومي",
  说明: "التوضيح",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. يتم اعتماد توقيت GMT+8 في الإحصائيات<br>2. يتم احتساب الأرباح اليومية بناءً على جميع الطلبات التي تمت تسويتها بين 00:00-23:59 بتوقيت GMT+8 (الوقت المحلي 00:00-23:59)<br>3. سيتم توزيع أرباح اليوم بشكل موحد في اليوم التالي بين 00:00-00:10 بتوقيت GMT+8.",
  知道了: "حسنًا",
  锁仓: "قفل",
  派息时间: "وقت توزيع الأرباح",
  每日: "يوميًا",
  托管资金: "الأموال المُدارة",
  到期返回: "إرجاع عند الاستحقاق",
  提前赎回: "استرداد مبكر",
  预计收益: "الأرباح المتوقعة",
  认购: "اشتراك",
  热门: "الأكثر شيوعًا",
  数字货币: "العملات الرقمية",
  贵金属: "المعادن الثمينة",
  大宗商品: "السلع الأساسية",
  持仓明细: "تفاصيل المراكز",
  历史明细: "السجل التاريخي",
  当前价: "السعر الحالي",
  "↑买涨": "↑ شراء صعود",
  "↓买跌": "↓ شراء هبوط",
  显示全部: "عرض الكل",
  买入金额: "مبلغ الشراء",
  方向: "الاتجاه",
  收益: "الأرباح",
  预期收益: "الأرباح المتوقعة",
  估用保证金: "الهامش التقديري",
  确认下单: "تأكيد الطلب",
  锁定: "مقفل",
  账户总资产: "إجمالي أصول الحساب",
  明细: "التفاصيل",
  今日收益: "أرباح اليوم",
  仓位保证金: "هامش المركز",
  持有仓位: "المراكز المحتفظ بها",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "المبلغ المقفل = إجمالي مبالغ جميع طلبات التعدين المقفل غير المكتملة",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. يتم اعتماد توقيت GMT+8 في الإحصائيات<br>2. يتم احتساب الأرباح اليومية بناءً على جميع الطلبات التي تمت تسويتها بين 00:00-23:59 بتوقيت GMT+8 (الوقت المحلي 00:00-23:59)",
  充值方式: "طريقة الإيداع",
  银行汇款: "حوالة بنكية",
  "银行汇款请联系客服进行操作!":
    "يرجى التواصل مع خدمة العملاء لإجراء الحوالة البنكية!",
  提款方式: "طريقة السحب",
  "银行提款请联系客服进行操作!":
    "يرجى التواصل مع خدمة العملاء لإجراء السحب البنكي!",
  资金明细: "تفاصيل الأموال",
  提现记录: "سجل السحب",
  拒绝: "رفض",
  通过: "تمت الموافقة",
  拒绝原因: "سبب الرفض",

  消息公告: "الإعلانات",
  订单: "الطلبات",
  个人中心: "المركز الشخصي",
  "未到期赎回需支付一定的违约金!":
    "في حالة الاسترداد قبل انتهاء المدة يجب دفع غرامة.",

  请输入区号: "يرجى إدخال رمز المنطقة",
  "请选择国家/地区": "يرجى اختيار الدولة/المنطقة",
  今日开盘: "افتتاح اليوم",
  昨日收盘: "إغلاق الأمس",

  实名认证即送: "احصل عليه فور إتمام التحقق من الهوية",
  立即认证: "تحقق الآن",
  新用户礼包: "هدية المستخدم الجديد",
  完成新人任务领取: "أكمل مهام المستخدم الجديد لاستلامها",
  认证: "التحقق",
  时间周期: "الفترة الزمنية",
  支付金额: "مبلغ الدفع",
  已平仓: "تم إغلاق الصفقة",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "حزمة ترحيب MGBX للمستخدمين الجدد: يمكن لكل مستخدم الحصول على حد أقصى",
  我已经阅读并同意: "لقد قرأت وأوافق على",
  隐私政策: "سياسة الخصوصية",

  放弃奖励离开: "التخلي عن المكافأة والمغادرة",
  继续注册: "متابعة التسجيل",
  分钟: "دقيقة",
  "请先勾选隐私政策!": "يرجى الاطلاع على سياسة الخصوصية أولاً!",
  添加其他到自选: "إضافة آخرين إلى قائمة المتابعة",
  充值最高可得: "قم بزيادة الرصيد واحصل على ما يصل إلى 30,000 دولار.",

  请输入格式正确的手机号: "يرجى إدخال رقم هاتف محمول صالح.",
  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 阿拉伯语



// WEBPACK FOOTER //
// ./src/lang/ar.js